// extracted by mini-css-extract-plugin
export default {"header":"styles_header__gQC8L","search":"styles_search__TPM55"};